<template>
  <transition name="fade" appear>
    <div class="partner-aside__background" @click.self="onOutsideClicked">
      <div class="partner-aside__marker" />
      <transition name="aside" appear>
        <aside class="partner-aside__container">
          <header class="partner-aside__header">
            <h3 class="header__text">
              {{ headerText }}
            </h3>
            <p class="header__steps-count">{{ currentStep }}/2 шагов</p>
          </header>
          <div class="partner-aside__body">
            <transition name="slide" mode="out-in">
              <section
                v-if="currentStep === 1"
                :key="currentStep"
                class="body body__edit"
              >
                <div class="edit__logo">
                  <div class="body__title">
                    Изображение логотипа <span>&nbsp;*</span>
                  </div>
                  <div class="logo__wrapper">
                    <div class="logo__logo">
                      <div class="logo__logo-border">
                        <img
                          v-if="provisionalCard.logo"
                          :src="provisionalCard.logo"
                        />
                        <div v-else class="logo__logo-icon">
                          <icon icon="picture-unknown" fill="#E8E8EE" />
                        </div>
                      </div>
                      <ui-file
                        v-if="!provisionalCard.logo"
                        data-name="logo"
                        medium-files
                        only-images
                        is-custom
                        :multiple="false"
                        @getFiles="loadLogo"
                      >
                        <div class="logo__logo-update -pointer-">
                          <icon icon="ui-camera" fill="#6979F8" />
                        </div>
                      </ui-file>
                    </div>
                    <div v-if="provisionalCard.logo" class="logo__controls">
                      <div
                        class="logo__control logo__control-edit"
                        @click="onLogoEdit"
                      >
                        <icon icon="ui-scale" />
                        Редактировать
                      </div>
                      <div
                        class="logo__control logo__control-delete"
                        @click="onLogoDelete"
                      >
                        <icon icon="delete" />
                        Удалить
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit__about">
                  <div class="body__title">
                    О партнёре <span> &nbsp;*</span>
                  </div>
                  <partner-input
                    v-model="$v.provisionalCard.name.$model"
                    title="Название"
                    required
                    placeholder="Напиши название партнёра"
                    :max-symbols="25"
                    :invalid="
                      $v.provisionalCard.name.$invalid &&
                      $v.provisionalCard.name.$dirty
                    "
                  />
                  <partner-input
                    v-model="$v.provisionalCard.description.$model"
                    title="Заголовок"
                    required
                    placeholder="Напиши описание партнёра"
                    :max-symbols="100"
                    type="textarea"
                    :invalid="
                      $v.provisionalCard.description.$invalid &&
                      $v.provisionalCard.description.$dirty
                    "
                  />
                  <partner-input
                    v-model="$v.provisionalCard.slug.$model"
                    title="Мнемоника"
                    required
                    placeholder="Напиши мнемонику партнера (напр. yandex или tochka)"
                    :max-symbols="25"
                    :invalid="
                      $v.provisionalCard.slug.$invalid &&
                      $v.provisionalCard.slug.$dirty
                    "
                    :invalid-text="
                      !$v.provisionalCard.slug.onlyLatin
                        ? 'Допустимы только символы латинского алфавита и цифры'
                        : ''
                    "
                  />
                </div>
                <div class="edit__condtitions">
                  <div class="body__title">Условия партнёра</div>
                  <partner-input
                    v-model="$v.provisionalCard.title.$model"
                    title="Предложение"
                    required
                    placeholder="Напиши предложение партнёра"
                    :max-symbols="50"
                    :invalid="
                      $v.provisionalCard.title.$invalid &&
                      $v.provisionalCard.title.$dirty
                    "
                  />
                  <partner-input
                    v-model="$v.provisionalCard.subtitle.$model"
                    title="Описание предложения"
                    placeholder="Напиши описание предложения партнёра"
                    :max-symbols="50"
                  />
                  <partner-input
                    v-model="$v.provisionalCard.url.$model"
                    title="Ссылка на предложение"
                    required
                    placeholder="Вставь URL ссылку на предложение"
                    type="url"
                    :invalid="
                      $v.provisionalCard.url.$invalid &&
                      $v.provisionalCard.url.$dirty
                    "
                    :invalid-text="
                      !$v.provisionalCard.url.url ? 'Некорректный URL' : ''
                    "
                  />
                </div>
              </section>
              <section
                v-if="currentStep === 2"
                :key="currentStep"
                class="body body__preview"
              >
                <div class="preview__header">
                  <div class="body__title">Карточка предложения партнёра</div>
                </div>
                <div class="preview__card">
                  <partner-card :card="provisionalCard" :preview-mode="true" />
                </div>
              </section>
            </transition>
          </div>
          <div class="partner-aside__delimiter" />
          <div class="partner-aside__footer">
            <ui-button
              class="btn__decline"
              color="primary-invert"
              @click="onBackClicked"
            >
              {{ declineButtonText }}
            </ui-button>
            <ui-button
              class="btn__accept"
              :disabled="
                $v.provisionalCard.$invalid ||
                !provisionalCard.logo ||
                isLoading
              "
              @click="onNextClicked"
            >
              <div v-if="!isLoading">
                {{ acceptButtonText }}
              </div>
              <ui-loader-dots v-if="isLoading" />
            </ui-button>
          </div>
        </aside>
      </transition>
      <ui-modal
        :value="showCropper"
        :show-footer="false"
        @close="onCropperClose"
      >
        <div class="logo__modal">
          <h3 class="modal__header">Изображение логотипа</h3>
          <cropper
            class="modal__cropper"
            :src="provisionalCard.logo"
            :stencil-component="$options.components.CircleStencil"
            @change="onImageCrop"
          />
          <div class="modal__footer">
            <ui-button color="primary-invert" @click="onCropperClose">
              Отмена
            </ui-button>
            <ui-button @click="onCropperAccept"> Загрузить </ui-button>
          </div>
        </div>
      </ui-modal>
    </div>
  </transition>
</template>

<script>
import { required, maxLength, url } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';
import { Cropper, CircleStencil } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

import UiButton from '@/components/UiKit/Button';
import UiFile from '@/components/UiKit/File';
import UiModal from '@/components/UiKit/Modal';
import UiLoaderDots from '@/components/UiKit/LoaderDots';
import PartnerInput from './PartnerInput';
import PartnerCard from './PartnerCard';

const onlyLatin = value => /^[a-zA-Z0-9]+$/.test(value) || !value;

export default {
  name: 'Aside',
  components: {
    UiButton,
    UiFile,
    UiModal,
    UiLoaderDots,
    Cropper,
    CircleStencil,
    PartnerInput,
    PartnerCard
  },
  props: {
    mode: {
      type: String,
      default: 'add',
      validator: function (v) {
        return ['add', 'edit'].includes(v);
      }
    },
    card: {
      type: Object,
      default: () => undefined
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currentStep: 1,
    provisionalCard: {
      slug: '',
      logo: undefined,
      file: undefined,
      name: '',
      description: '',
      title: '',
      subtitle: '',
      url: ''
    },
    showCropper: false,
    croppedImage: undefined,
    file: undefined,
    logoFile: undefined
  }),
  validations: {
    provisionalCard: {
      name: {
        required,
        maxLength: maxLength(25)
      },
      description: {
        required,
        maxLength: maxLength(100)
      },
      slug: {
        required,
        maxLength: maxLength(25),
        onlyLatin
      },
      title: {
        required,
        maxLength: maxLength(50)
      },
      subtitle: {
        maxLength: maxLength(50)
      },
      url: {
        required,
        url
      }
    }
  },
  computed: {
    headerText() {
      return this.mode === 'add'
        ? 'Создание партнёра'
        : 'Редактирование партнёра';
    },
    declineButtonText() {
      return this.currentStep === 1 ? 'Отменить' : 'Назад';
    },
    acceptButtonText() {
      if (this.currentStep === 1) {
        return 'Следующий шаг';
      } else if (this.mode === 'add') {
        return 'Запустить предложение';
      } else {
        return 'Сохранить изменение';
      }
    }
  },
  created() {
    if (this.card && this.mode === 'add') {
      this.provisionalCard = cloneDeep(this.card);
    }
  },
  methods: {
    loadLogo(event) {
      console.log(event);
      this.provisionalCard.logo = URL.createObjectURL(event.file);
      this.provisionalCard.file = event.file;
    },
    onLogoDelete() {
      this.provisionalCard.logo = undefined;
      this.provisionalCard.file = undefined;
      this.showCropper = false;
    },
    onLogoEdit() {
      this.openCropper();
    },
    openCropper() {
      this.showCropper = true;
    },
    onCropperClose() {
      this.showCropper = false;
    },
    onCropperAccept() {
      this.showCropper = false;
      this.provisionalCard.logo = this.croppedImage;
      this.provisionalCard.file = this.file;
    },
    onImageCrop(event) {
      this.croppedImage = event.canvas.toDataURL();
      event.canvas.toBlob(blob => {
        this.file = blob;
      });
    },
    nextStep() {
      this.currentStep++;
    },
    previousStep() {
      this.currentStep--;
    },
    onNextClicked() {
      if (this.currentStep === 1) {
        this.nextStep();
      } else {
        this.onAcceptClicked();
      }
    },
    onBackClicked() {
      if (this.currentStep === 1) {
        this.onRejectClicked();
      } else {
        this.previousStep();
      }
    },
    onOutsideClicked() {
      this.$emit('close');
    },
    onRejectClicked() {
      this.$emit('reject');
    },
    onAcceptClicked() {
      this.$emit('accept', this.provisionalCard);
    }
  }
};
</script>

<style scoped lang="scss">
@import 'style/utils';

.partner-aside {
  &__background {
    position: fixed;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
  }

  &__marker {
    height: 40px;
    width: 6px;
    background: rgba(255, 255, 255, 0.6);
    margin: 0 14px;
    border-radius: 4px;
    float: right;

    @include media(420px) {
      display: none;
    }
  }

  &__container {
    height: 100vh;
    width: 100%;
    flex-grow: 1;
    padding: 40px 80px;
    min-width: 320px;
    max-width: 600px;
    border-radius: 20px 0 0 20px;
    background: $ui-white;
    @include uiFont;
    transition: all 0.8s ease;
    @include media(425px) {
      padding: 40px 20px;
    }
  }

  &__header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .header {
      &__text {
        @extend %text-500-18;
        color: $ui-black;
      }

      &__steps-count {
        @extend %text-400-18;
        color: $ui-light-grey-4-5-contrast;
      }
    }
  }

  &__body {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 75vh;
    margin-right: -10px;
    padding-right: 10px;

    .body {
      & > div {
        margin-top: 32px;
      }

      &__title {
        @extend %text-500-16;

        span {
          vertical-align: top;
          color: $ui-red;
        }
      }

      .edit {
        &__logo {
          .logo {
            &__wrapper {
              display: flex;
              justify-content: flex-start;
            }
            &__controls {
              margin-top: 14px;
              margin-left: 24px;
            }
            &__control {
              margin-bottom: 10px;
              cursor: pointer;
              @extend %text-400-14;
              display: flex;
              &-edit svg {
                fill: $ui-light-grey-4-5-contrast;
                height: 16px;
                width: 16px;
              }
              &-delete svg {
                fill: $ui-red;
                height: 16px;
                width: 16px;
              }
              svg {
                margin-right: 8px;
              }
            }

            &__logo {
              @include size(68px);
              position: relative;
              margin-top: 14px;
            }
            &__logo-border {
              @include size(68px);
              overflow: hidden;
              border-radius: 34px;
            }
            &__logo-icon {
              @include size(68px);
              padding: 22px;
              background: $main-bg;
              & svg {
                @include size(24px);
              }
            }
            &__logo-update {
              position: absolute;
              display: block;
              background: #d8defd;
              padding: 2px;
              border-radius: 4px;
              border: 2px solid #f7f7fb;
              bottom: -3px;
              right: -3px;
              box-shadow: 0 6px 8px 0 #1b23631a;
              & svg {
                width: 16px;
                height: 12px;
              }
            }
          }
        }
      }
      .preview__card {
        padding: 20px 20px;
      }
    }
  }

  &__delimiter {
    background: $ui-light-grey-low-contrast;
    height: 1px;
    width: 100%;
    margin-top: 14px;
  }

  &__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 20px;

    & button {
      min-width: unset;
    }
  }
}

.logo__modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  @include uiFont;

  .modal {
    &__header {
      @extend %text-700-18;
    }

    &__cropper {
      height: 300px;
      margin-top: 20px;
    }

    &__footer {
      display: flex;
      flex-direction: row;
      margin-top: 20px;

      button {
        min-width: unset;
        flex-grow: 1;
        &:first-child {
          margin-right: 8px;
        }
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter {
  transform: translate(100%, 0);
  opacity: 1;
}
.slide-leave-to {
  transform: translate(-100%, 0);
  opacity: 0;
}
</style>
